export const ECO_SETTINGS_RECEIVED = "ECO_SETTINGS_RECEIVED";
